// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"18529d1e","147":"a22d8639","427":"77f486d8","899":"ee1128bf","900":"a4473663"}[chunkId] + ".chunk.js";
};